// extracted by mini-css-extract-plugin
module.exports = {"section":"Intro_section__Ee2UG","box":"Intro_box__1WgPm","icon":"Intro_icon__xMEgY","fb":"Intro_fb__IxuqB","ig":"Intro_ig__ekr_P","gh":"Intro_gh__UZZ7t"};